import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {InfoTokenService, TranslateService} from "@mangosoft/mango-layout";
import {ActivityI} from "../../../../infrastructure/interfaces/task.interface";

export interface MangoServiceConfig {
  api: string;
  template: string;
  token: string;
  border?: string;
}

export interface MangoServiceInput {
  config: MangoServiceConfig;
  data: any;
}


@Component({
  selector: 'app-services-preview',
  templateUrl: './services-preview.component.html',
  styleUrls: ['./services-preview.component.scss']
})
export class ServicesPreviewComponent implements OnDestroy, OnInit {

  @Input() activityData: ActivityI | null = null;

  destroy$ = new Subject<void>();

  language: string = "es";
  token!: string;

  data!: string;

  constructor(
    private translateService: TranslateService,
    private authService: InfoTokenService
  ) {
  }

  ngOnInit() {
    this.token = this.authService.getToken();

    if (this.activityData?.api){
      this.data = JSON.stringify({
        config: {
          template: this.activityData?.previewTemplate,
          api: this.activityData.api,
          token: this.token,
          border: this.activityData?.previewBorder,
          background: this.activityData?.previewBackground
        },

        data: this.activityData?.metadata
      })
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
